const store_id = 'Xi8KgyMctkoGKyOqXd9GzbzRt5EdIxkGIdtU5JOm'

const selectors = {
  ratingStar: '[data-rating-star]',
  ratingCount: '[data-rating-count]',
}

const STAR_CLASSES = {
  empty: 'rating-star--empty',
  half: 'rating-star--half',
  full: 'rating-star--full',
}

class RatingStars extends HTMLElement {
  #ratingStars;
  #ratingCount;
  #productId;
  #data;
  
  constructor() {
    super();

    this.render = this.render.bind(this);
  }

  render() {
    if (!this.#data || !this.#ratingCount) return;

    this.setAttribute('data-loaded', 'true');

    this.#ratingCount.textContent = this.#data.total;

    this.#ratingStars.forEach(star => {
      const rating = Number(star.dataset.ratingStar ?? 0);

      if (rating > this.#data.average) {
        star.classList.add(STAR_CLASSES.empty);
      } else if (rating < this.#data.average && rating > this.#data.average - 1) {
        star.classList.add(STAR_CLASSES.half);
      } else {
        star.classList.add(STAR_CLASSES.full);
      }
    })
  }

  async fetchReviews() {
    const endpoint = `https://api.yotpo.com/v1/widget/${store_id}/products/${this.#productId}/reviews.json?per_page=1`

    try {
      const response = await fetch(endpoint);
      
      const data = await response.json();

      if (!data?.response || data?.status?.code !== 200) {
        throw new Error('Failed to fetch reviews from Yotpo');
      }

      this.#data = {
        total: data.response.bottomline?.total_review ?? 0,
        average: data.response.bottomline?.average_score ?? 0,
        reviews: data.response.reviews ?? []
      }

      this.render();
    } catch (error) {
      console.error(error);
    }
  }

  connectedCallback() {
    this.#ratingStars = this.querySelectorAll(selectors.ratingStar);
    this.#ratingCount = this.querySelector(selectors.ratingCount);

    this.#productId = this.dataset.productId;

    this.fetchReviews();
  }
}

if (!customElements.get('rating-stars')) {
  customElements.define('rating-stars', RatingStars);
}